const endpoints = {
  BASE_URL: process.env.VUE_APP_API_URL,
  LARAVEL_BASE_URL: process.env.VUE_APP_LARAVEL_API_URL,
  COUNTER_SALE_USER_ID: process.env.VUE_APP_COUNTER_SALE_USER_ID,
  API: {
    products: "/api/v1/products",
    taxes: "/api/v1/taxes",
    productUnits: "/api/v1/product-units",
    productPriceTypes: "/api/v1/product-price-types",
    users: "/api/v1/users",
    sales: "/api/v1/sales",
    paymentModes: "/api/v1/payment-modes",
    roles: "/api/v1/roles",
    suppliers: "/api/v1/suppliers",
    expenseTypes: "/api/v1/expense-types",
    expenses: "/api/v1/expenses",
    attributes: "/api/v1/attributes",
    invoices: "/api/v1/invoices",
    creditNotes: "/api/v1/credit-notes",
    serviceCategories: "/api/v1/service-categories",
    serviceRequests: "/api/v1/service-requests",
    services: "/api/v1/services",
    statuses: "/api/v1/statuses",
    serviceJobs: "/api/v1/service-jobs",
    vendors: "/api/v1/vendors",
    vendorTypes: "/api/v1/vendor-types",
    serviceRequestJobs: "/api/v1/service-request-jobs",
    laborCosts: "/api/v1/labor-costs",
    jobs: "/api/v1/jobs",
    serviceRequestLogs: "/api/v1/service-request-logs",
    serviceRequestPointsTimeline: "/api/v1/service-requests",
    purchases: "/api/v1/purchases",
    billRequests: "/api/v1/bill-requests",
    inquiries: "/api/v1/inquiries",
    attendance: "/api/v1/attendance"
  },
  PRINTER_API_URL: process.env.VUE_APP_PRINTER_API,
  PRINT_API: {
    sale: "/api/v1/sale",
    quotation: "/api/v1/quotation",
    chalan: "/api/v1/chalan"
  }
};

export default endpoints;
